"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Builds the relative URL for a Contentful Entry from its fields
 *
 * @param {object} paths - An array of paths
 * @returns {string} - The relative URL for the Entity
 */
var buildEntityUrl = function buildEntityUrl(paths) {
  var valid = paths.filter(function (path) {
    return !!path;
  });
  return "/".concat(valid.join('/'));
};
var _default = buildEntityUrl;
exports["default"] = _default;